import { useEnvironment } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import Button from '../../../../../../../common/components/Button';
import { useWidget } from '../../../../../../../contexts/widgets';
import { absorbArguments } from '../../../../../../../services/event-handler';
import { DataHook, ProfileAlignment } from '../../../../../../../types';
import styles from './Followers.scss';

export const Followers: FC = () => {
  const { isRTL } = useEnvironment();
  const { member, globalSettings, handlers, computed } = useWidget();

  const { ffLightboxEnabled, ffLightboxInstalled } = globalSettings;
  const { followersInstalled, profileWidgetTexts, profileAlignment } = computed;

  const isCTADisabled = !ffLightboxEnabled && !followersInstalled;

  const handleFollowersBoxClick = absorbArguments(() => {
    if (ffLightboxInstalled) {
      return handlers.showFollowers();
    }

    handlers.navigateToViewedMemberFFPage(true);
  });

  const handleFollowingBoxClick = absorbArguments(() => {
    if (ffLightboxInstalled) {
      return handlers.showFollowing();
    }

    handlers.navigateToViewedMemberFFPage(false);
  });

  const isRightAlignment =
    profileAlignment === ProfileAlignment.Right && !isRTL;
  const isCenterAlignment = profileAlignment === ProfileAlignment.Center;

  return (
    <div
      data-hook={DataHook.FollowersFollowing}
      className={classNames({
        [styles.numbersBox]: true,
        [styles.isRightAlignment]: isRightAlignment,
        [styles.isCenterAlignment]: isCenterAlignment,
      })}
    >
      <div
        data-hook={DataHook.Followers}
        className={styles.followersBoxContainer}
      >
        <Button
          className={classNames(styles.button, styles.numbersBoxFollowers, {
            [styles.disabled]: isCTADisabled,
          })}
          onClick={handleFollowersBoxClick}
          isDisabled={isCTADisabled}
        >
          <span>{member.followerCount}</span>
          <div className={styles.numbersBoxText}>
            {profileWidgetTexts.followersCountersText}
          </div>
        </Button>
      </div>
      <div className={styles.divider} />
      <div data-hook={DataHook.Following}>
        <Button
          className={classNames(styles.button, styles.numbersBoxFollowing, {
            [styles.disabled]: isCTADisabled,
          })}
          onClick={handleFollowingBoxClick}
          isDisabled={isCTADisabled}
        >
          <span>{member.followingCount}</span>
          <div className={styles.numbersBoxText}>
            {profileWidgetTexts.followingCountersText}
          </div>
        </Button>
      </div>
    </div>
  );
};
